import { v4 as uuidv4 } from "uuid";

let sessionId = null;

function generateSessionId() {
  // 使用 UUID v4 生成 session ID
  return uuidv4();
}

const getSessionId = () => {
  if (!sessionId) {
    sessionId = generateSessionId();
  }
  return sessionId;
};

export default getSessionId;
